import { cn } from '../../lib/cn';
import type { GovernanceComplianceRow } from '../../masterplatform/framework';

type Props = { items?: GovernanceComplianceRow[] };

export function GovernanceCompliancePanel({ items = [] }: Props) {
  return (
    <div className="grid gap-2 sm:grid-cols-2">
      {items.map((item) => (
        <div key={item.rule} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div>
            <p className="text-sm font-medium">{item.rule}</p>
            <p className="text-xs text-slate-500">{item.severity}</p>
          </div>
          <span className={cn(
            'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
            item.status === 'compliant'
              ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300'
              : 'bg-error-50 text-error-700 dark:bg-error-950 dark:text-error-300',
          )}>
            {item.status}
          </span>
        </div>
      ))}
    </div>
  );
}
